<template>
  <div id="course" :style="podcastAudioSrc ? 'padding-bottom: 80px;' : ''">
    <section class="course-title-container">
      <v-banner
        two-line
        class="mt-4 pt-3 pl-2 ml-2 pr-2 pb-0"
        v-if="this.showBannerReview"
      >
        <v-avatar slot="icon" color="deep-purple accent-4" size="40">
          <v-icon icon="mdi-lock" color="white"> comment </v-icon>
        </v-avatar>
        É muito importante sabermos sobre a sua experiência conosco. Você
        poderia reservar 3 minutos para conversarmos?
        <template v-slot:actions>
          <v-btn text color="deep-purple accent-4" @click="answerBanner(false)"
            >Agora não</v-btn
          >
          <v-btn text color="deep-purple accent-4" @click="answerBanner(true)"
            >Claro!</v-btn
          >
        </template>
      </v-banner>
      <div class="course-dashboard">
        <template v-if="loading">
          <v-card class="rounded-xl mt-5">
            <v-skeleton-loader type="article"></v-skeleton-loader>
          </v-card>
        </template>

        <template v-else>
          <div class="course-header">
            <h1 style="line-height: 1.1">{{ this.course.course }}</h1>
            <div class="text-h6">{{ this.course.description }}</div>
          </div>
        </template>
      </div>
    </section>
    <div class="mt-5">
      <v-card v-if="loading" class="rounded-xl pa-5 pt-10">
        <v-skeleton-loader
          v-for="i in 8"
          type="text"
          class="my-8"
        ></v-skeleton-loader>
      </v-card>
      <v-tabs
        v-else
        grow
        color="primary"
        class="rounded-t-xl elevation-1"
        style="margin-bottom: 40px"
        v-model="selectedTab"
      >
        <v-tab href="#lessons" :key="'lessons'">
          <v-icon class="pr-2">video_library</v-icon>
          <span v-if="!isMobileTabs || selectedTab === 'lessons'">Aulas</span>
        </v-tab>
        <v-tab
          v-if="podcastSections.length > 0"
          href="#podcast"
          :key="'podcast'"
        >
          <v-icon class="pr-2">headphones</v-icon>
          <span v-if="!isMobileTabs || selectedTab === 'podcast'">
            Podcasts
          </span>
        </v-tab>
        <v-tab href="#downloads" :key="'downloads'">
          <v-icon class="pr-2">download</v-icon>
          <span v-if="!isMobileTabs || selectedTab === 'downloads'">
            Downloads
          </span>
        </v-tab>
        <v-tab-item
          v-if="podcastSections.length > 0"
          :key="'3'"
          :value="'podcast'"
        >
          <v-card flat>
            <v-list two-line>
              <v-list-group
                v-for="(section, index) in podcastSections"
                :key="section.id"
                no-action
              >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title
                      style="
                        white-space: initial;
                        font-family: &quot;Google Sans&quot;,
                          &quot;Google Sans Text&quot;, sans-serif !important;
                      "
                      class="text-h6"
                    >
                      <v-icon class="pa-2" color="primary">headphones</v-icon>
                      {{ section.title }}
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
                <template v-for="podcast in section.podcasts">
                  <v-list-item :key="podcast.id" class="pl-12">
                    <v-list-item-avatar>
                      <v-icon color="primary">headphones</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title
                        v-text="podcast.title"
                      ></v-list-item-title>
                      <v-list-item-subtitle
                        v-text="podcast.description"
                      ></v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn icon @click="playPodcast(podcast)">
                        <v-icon color="primary">play_circle_filled</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider :inset="true"></v-divider>
                </template>
              </v-list-group>
            </v-list>
          </v-card>
        </v-tab-item>

        <v-tab-item :key="'2'" :value="'downloads'">
          <v-card flat>
            <v-list
              two-line
              v-if="
                sections.filter(
                  (section) =>
                    section.items.data.filter((item) =>
                      offline_section_items.find(
                        (offline_item) => offline_item.id == item.id,
                      ),
                    ).length,
                ).length > 0
              "
            >
              <v-list-group
                v-for="(section, index) in sections.filter(
                  (section) =>
                    section.items.data.filter((item) =>
                      offline_section_items.find(
                        (offline_item) => offline_item.id == item.id,
                      ),
                    ).length,
                )"
                :key="section.id"
                no-action
              >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title
                      style="
                        white-space: initial;
                        font-family: &quot;Google Sans&quot;,
                          &quot;Google Sans Text&quot;, sans-serif !important;
                      "
                      class="text-h6"
                    >
                      <v-icon class="pa-2" color="primary">
                        video_library
                      </v-icon>
                      {{ section.title }}
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
                <template
                  v-for="(item, index2) in section.items.data.filter((item) =>
                    offline_section_items.find(
                      (offline_item) => offline_item.id == item.id,
                    ),
                  )"
                >
                  <v-list-item
                    :disabled="!item.is_published"
                    :key="item.id"
                    class="pl-12"
                    :to="{
                      name: 'classroom',
                      params: {
                        courseId: course.id,
                        sectionItemId: item.id,
                        slug: item.learnable.slug,
                      },
                    }"
                  >
                    <div class="justify-center align-middle pa-3">
                      <div>
                        <v-icon
                          :color="item.log ? 'primary' : 'grey lighten-1'"
                        >
                          check_circle
                        </v-icon>
                      </div>
                    </div>
                    <v-list-item-content>
                      <v-list-item-title
                        style="white-space: pre-wrap"
                        v-html="item.description"
                      ></v-list-item-title>
                      <v-list-item-subtitle
                        v-html="item.learnable.description"
                      ></v-list-item-subtitle>
                    </v-list-item-content>
                    <div class="justify-center align-middle pa-3">
                      <v-progress-circular
                        indeterminate
                        style="margin-right: 6px"
                        size="24"
                        v-if="loading_deletion[item.id]"
                      />
                      <div
                        @click="(event) => deleteVideo(event, item.id)"
                        v-else
                      >
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on" :color="'grey lighten-1'">
                              delete
                            </v-icon>
                          </template>
                          <span
                            >Clique aqui para deletar o download da aula</span
                          >
                        </v-tooltip>
                      </div>
                    </div>
                  </v-list-item>
                </template>
              </v-list-group>
            </v-list>
            <v-list v-else>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    Nenhum item disponível offline
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-tab-item>

        <v-tab-item :key="'1'" :value="'lessons'">
          <v-card flat>
            <v-list two-line>
              <v-list-group
                v-for="(section, index) in sections"
                :key="section.id"
                no-action
              >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title
                      style="
                        white-space: initial;
                        font-family: &quot;Google Sans&quot;,
                          &quot;Google Sans Text&quot;, sans-serif !important;
                      "
                      class="text-h6"
                    >
                      <v-icon class="pa-2" color="primary">
                        video_library
                      </v-icon>
                      {{ section.title }}
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
                <template v-for="(item, index2) in section.items.data">
                  <v-list-item
                    :disabled="
                      !item.is_published ||
                      (!hasOfflineSupport[item.id] && isOffline)
                    "
                    class="pl-12"
                    :key="item.id"
                    :to="{
                      name: 'classroom',
                      params: {
                        courseId: course.id,
                        sectionItemId: item.id,
                        slug: item.learnable.slug,
                      },
                    }"
                  >
                    <div class="justify-center align-middle pa-3">
                      <div>
                        <v-icon
                          :color="item.log ? 'primary' : 'grey lighten-1'"
                        >
                          check_circle
                        </v-icon>
                      </div>
                    </div>
                    <v-list-item-content>
                      <v-list-item-title
                        style="white-space: pre-wrap"
                        v-html="item.description"
                      ></v-list-item-title>
                      <v-list-item-subtitle
                        v-html="item.learnable.description"
                      ></v-list-item-subtitle>
                    </v-list-item-content>
                    <div
                      class="justify-center align-middle pa-3"
                      v-if="item.learnable.download"
                    >
                      <v-progress-circular
                        indeterminate
                        style="margin-right: 6px"
                        size="24"
                        v-if="loading_offline_support[item.id]"
                      />
                      <div
                        @click="
                          (event) =>
                            downloadVideo(
                              event,
                              item.learnable.content_identifier,
                              item.id,
                              item,
                            )
                        "
                        v-else
                      >
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-icon
                              v-on="on"
                              :color="
                                hasOfflineSupport[item.id]
                                  ? 'green'
                                  : 'grey lighten-1'
                              "
                            >
                              download
                            </v-icon>
                          </template>
                          <span>{{
                            hasOfflineSupport[item.id]
                              ? "Vídeo disponível offline!"
                              : "Clique aqui para fazer o download da aula"
                          }}</span>
                        </v-tooltip>
                      </div>
                    </div>
                  </v-list-item>
                  <v-divider :inset="true"> </v-divider>
                </template>
              </v-list-group>
            </v-list>
          </v-card>
        </v-tab-item>
      </v-tabs>
      <v-dialog v-model="showDialog" max-width="500">
        <v-card style="background-color: #05021f">
          <img
            src="https://s3.us-east-1.amazonaws.com/content.professorlucassilva.com.br/assets/images/banner-sharkhunter.jpg"
            alt="Banner"
            style="width: 100%; cursor: pointer"
            @click="openLinkAndCloseDialog"
          />
        </v-card>
      </v-dialog>
      <!-- complex chart -->
      <v-layout row wrap> </v-layout>
      <div v-if="podcastAudioSrc" class="fixed-podcast-player">
        <PodcastPlaylist
          :src="podcastAudioSrc"
          :playlist="currentPodcastList"
          :current-index="currentPodcastIndex"
          :force-play="forcePodcastPlay"
          @play-next="playNextPodcast"
          @play-prev="playPrevPodcast"
          @ended="playNextPodcast"
          @close="podcastAudioSrc = null"
        />
      </div>
    </div>
    <AITools
      :course-id="parseInt(course.id)"
      :preparation-stage="parseInt(statusActive)"
      :guide-assistant="course.learning_guide_assistant"
      :chat-assistant="course.chat_assistant"
      :is-guide-chat="true"
    />
  </div>
</template>

<script>
import Material from "vuetify/es5/util/colors";
import VWidget from "@/components/VWidget";
import CourseService from "../../services/courses.service";
import SwService from "../../services/sw.service";
import DeviceDetector from "device-detector-js";

const deviceDetector = new DeviceDetector();

import { CONFIG } from "@/config";
import LearningGuideDialog from "../../components/learningGuide/LearningGuideDialog.vue";
import AITools from "../../components/aiTools/AITools.vue";
import PodcastPlaylist from "@/components/PodcastPlaylist.vue";

export default {
  components: {
    VWidget,
    LearningGuideDialog,
    AITools,
    PodcastPlaylist,
  },
  mounted() {
    this.selectedTab = window.location.hash.replace("#", "") || "lessons";

    this.checkUrl();

    window.addEventListener("offline", () => {
      console.log("went off");
      this.isOffline = true;
    });
    window.addEventListener("online", () => {
      console.log("went on");
      this.isOffline = false;
    });
  },
  data() {
    return {
      isOffline: !navigator.onLine,
      selectedTab: null,
      option: null,
      color: Material,
      course: {},
      sections: [],
      sections_items: {},
      offline_section_items: [],
      loading_offline_support: {},
      loading_deletion: {},
      hasOfflineSupport: {},
      loading: true,
      showBannerReview: false,
      reviewKey: null,
      showDialog: false,
      actualDialogDelayInDays: 10,
      statusActive: null,
      podcastSections: [],
      podcastAudioSrc: null,
      menu: false,
      currentPodcastList: [],
      currentPodcastIndex: 0,
      forcePodcastPlay: false,
    };
  },
  watch: {
    selectedTab(val) {
      if (this.$route) {
        this.$router.replace({ hash: val });
      } else {
        window.location.hash = val;
      }
    },
  },
  computed: {
    isMobileTabs() {
      return this.$vuetify.breakpoint.width <= 600;
    },
  },
  metaInfo() {
    return {
      title:
        this.course != null ? "LS - Curso " + this.course.course : "LS - Curso",
      meta: [
        {
          vmid: "description",
          name: "description",
          content:
            this.course != null
              ? "LS - Curso " + this.course.description
              : "Curso preparatório para certificações financeiras",
        },
      ],
    };
  },
  created() {
    // console.log(this.$refs.chart)
    const offline_support_ids = Object.keys(localStorage)
      .filter((x) => x.startsWith("hasOfflineSupport_"))
      .map((x) => x.replace("hasOfflineSupport_", ""))
      .filter((_) => _);

    for (const id of offline_support_ids) {
      this.hasOfflineSupport[id] = true;
    }

    this.loadCourse();
    this.reviewKey = "review-" + this.$route.params.courseId;
  },
  methods: {
    log(...rest) {
      console.log({ rest });
    },
    async deleteVideo(event, itemId) {
      event.preventDefault();
      this.loading_deletion[itemId] = true;
      this.$forceUpdate();
      caches
        .open(CONFIG.CACHEV)
        .then(async () => {
          localStorage.removeItem("hasOfflineSupport_" + itemId);
          this.hasOfflineSupport[itemId] = false;
          this.loading_deletion[itemId] = false;
          window.getApp.sendSnackMessage(
            "Download de aula deletado",
            "success",
          );
          this.offline_section_items = Object.keys(localStorage)
            .filter((x) => x.startsWith("hasOfflineSupport_"))
            .map(
              (x) => this.sections_items[x.replace("hasOfflineSupport_", "")],
            )
            .filter((_) => _);
          this.$forceUpdate();
        })
        .catch((error) => {
          console.error("Error during video deletion:", error);
          // Reset loading state
          this.loading_deletion[itemId] = false;
          this.$forceUpdate();
          // Notify the user of the failure
          window.getApp.sendSnackMessage(
            "Erro ao deletar o download da aula. Tente novamente.",
            "error",
          );
        });
    },

    async downloadVideo(event, contentIdentifier, itemId, item) {
      event.preventDefault();

      if (this.isOffline) {
        window.getApp.sendSnackMessage(
          "Você está offline, não é possível fazer o download",
          "error",
        );
        return;
      }
      caches
        .open(CONFIG.CACHEV)
        .then((cache) => {
          return cache.addAll([
            `/courses/${this.course.id}/${this.course.slug}`,
          ]);
        })
        .catch(console.warn);

      this.$set(this.loading_offline_support, itemId, true);
      this.$forceUpdate();

      if (!sessionStorage.getItem("offlineWarn")) {
        sessionStorage.setItem("offlineWarn", true);
        window.getApp.sendSnackMessage(
          "Não saia do site durante o download",
          "warning",
        );
      }

      let course = `/courses/${this.course.id}/${this.course.slug}`;
      let courseItem = `/api/v1/courses/items/${itemId}?include=learnable.video&checkContractAgreement=true`;
      let ratings = `api/v1/ratings/${itemId}`;
      let classUrl = `/courses/${this.course.id}/classroom/${itemId}/${item.learnable.slug}`;
      let videoLink;
      try {
        videoLink = await CourseService.getVideoLink(contentIdentifier);
      } catch (error) {
        videoLink = null;
      }

      let videoResolution = await CourseService.getResolutionDownload(
        videoLink,
        this.isMobile(),
      );

      if (videoResolution === null) {
        this.$set(this.loading_offline_support, itemId, false);
        window.currentlyDonwloading -= 1;
        window.getApp.sendSnackMessage(
          "Não é possível fazer o download deste vídeo",
          "warning",
        );
        return;
      }
      try {
        let resources = [
          course,
          courseItem,
          videoResolution,
          ratings,
          classUrl,
        ];
        // Check if resources are in the cache
        const cacheResources = await SwService.cacheResources(resources);
        if (cacheResources === "QuotaExceededError") {
          this.$set(this.loading_offline_support, itemId, false);
          window.getApp.sendSnackMessage(
            "Você atingiu o limite de armazenamento offline, por favor, delete alguns downloads",
            "warning",
          );
        } else if (cacheResources) {
          localStorage.setItem("hasOfflineSupport_" + itemId, 1);
          this.hasOfflineSupport[itemId] = true;
          this.$set(this.loading_offline_support, itemId, false);
          window.getApp.sendSnackMessage(
            "Download de aula finalizado",
            "success",
          );

          this.offline_section_items = Object.keys(localStorage)
            .filter((x) => x.startsWith("hasOfflineSupport_"))
            .map(
              (x) => this.sections_items[x.replace("hasOfflineSupport_", "")],
            )
            .filter((_) => _);
          this.$forceUpdate();
        } else {
          this.$set(this.loading_offline_support, itemId, false);
          window.getApp.sendSnackMessage(
            "Conexão instável para download, tente novamente mais tarde.",
            "error",
          );
        }
      } catch (error) {
        window.getApp.sendSnackMessage("Erro ao fazer download", "error");
        this.$set(this.loading_offline_support, itemId, false);
        this.$forceUpdate();
      } finally {
        window.currentlyDonwloading -= 1;
      }
    },

    isMobile() {
      return this.$vuetify.breakpoint.xs;
    },
    handleTabChange(val, e) {
      // make sure the chart resized while parent from hidden to show
      window.dispatchEvent(new Event("resize"));
    },
    loadCourse() {
      let totalRequests = 2;
      let totalFinishedRequests = 0;
      CourseService.getCourseById(this.$route.params.courseId)
        .then((response) => {
          this.course = response.data;
          this.metaInfo.titleTemplate = "%s - Curso " + this.course.course;
          this.$store.dispatch("changeCourse", this.course);
          this.checkCourseReview();
          totalFinishedRequests++;
          this.stopMainLoading(totalRequests, totalFinishedRequests);
        })
        .catch((err) => {
          const res = err.res;
          if (err.status === 404 || err.status === 403) {
            this.$router.push("/courses");
          }
          totalFinishedRequests++;
          this.stopMainLoading(totalRequests, totalFinishedRequests);
        });
      CourseService.getSectionsByCourseId(this.$route.params.courseId)
        .then((response) => {
          this.sections = response.data;
          this.sections_items = this.sections.reduce((acc, section) => {
            for (const item of section.items.data) {
              if (item && item.id) {
                acc[item.id] = item;
              }
            }
            return acc;
          }, {});

          this.offline_section_items = Object.keys(localStorage)
            .filter((x) => x.startsWith("hasOfflineSupport_"))
            .map(
              (x) => this.sections_items[x.replace("hasOfflineSupport_", "")],
            )
            .filter((_) => _);
          this.loadPodcastSections();
          totalFinishedRequests++;
          this.stopMainLoading(totalRequests, totalFinishedRequests);
        })
        .catch((err) => {
          totalFinishedRequests++;
          this.stopMainLoading(totalRequests, totalFinishedRequests);
          console.log(err);
          if (this.isOffline) {
            window.getApp.sendSnackMessage(
              "Primeiro acesse esse conteúdo com internet para que possa ficar disponível offline",
              "error",
            );
          }
        });
    },

    stopMainLoading(totalRequests, totalFinishedRequests) {
      if (totalRequests <= totalFinishedRequests) {
        this.loading = false;
      }
    },

    defineResolution(linksObject) {
      if (linksObject === null) {
        return null;
      }
      if (this.isMobile()) {
        return (
          obj.data.media_mobile_url ||
          obj.data.media_sd_url ||
          obj.data.media_hd_url ||
          null
        );
      } else {
        return obj.data.media_hd_url || obj.data.media_sd_url || null;
      }
    },

    checkCourseReview() {
      // console.log(this.course)
      if (!this.course.review_available) return;
      let review = localStorage.getItem(this.reviewKey);
      if (review !== null) review = new Date(review);
      const today = new Date();
      if (review == null || review < today) {
        this.showBannerReview = true;
      }
    },
    getUserBrowser() {
      try {
        const dd = deviceDetector.parse(navigator.userAgent);
        let client = "";

        if (dd.client) {
          client = `${dd.client.name}`;
        }
        return client;
      } catch (e) {
        console.log(e);
      }
    },
    checkUrl() {
      const currentUrl = window.location.href;

      if (currentUrl.endsWith("courses/7133/ancord")) {
        const lastShownTime = localStorage.getItem("dialogLastShown");
        const now = new Date().getTime();
        const delayInMilliseconds =
          this.actualDialogDelayInDays * 24 * 60 * 60 * 1000;

        if (!lastShownTime || now - lastShownTime > delayInMilliseconds) {
          this.showDialog = true;
          localStorage.setItem("dialogLastShown", now);
        }
      }
    },
    closeDialog() {
      localStorage.setItem("dialogLastShown", new Date().getTime());
      this.showDialog = false;
    },
    openLinkAndCloseDialog() {
      window.open(
        "https://docs.google.com/forms/d/e/1FAIpQLSexC_CVFlQ-WW36ST0Z5ejVZbbFkLeBTaMVuwH781MLTIWusw/viewform",
        "_blank",
      );
      this.showDialog = false;
    },
    answerBanner(answer) {
      var today = new Date();
      if (answer) {
        today.setDate(today.getDate() + 120);
        localStorage.setItem(this.reviewKey, today);
        window.open(this.course.review_url, "_blank");
      } else {
        today.setDate(today.getDate() + 30);
        localStorage.setItem(this.reviewKey, today);
      }
      this.showBannerReview = false;
    },
    playPodcast(podcast) {
      const allPodcasts = this.podcastSections.flatMap(
        (section) => section.podcasts,
      );
      const index = allPodcasts.findIndex((p) => p.id === podcast.id);

      this.currentPodcastList = allPodcasts;
      this.currentPodcastIndex = index;
      this.podcastAudioSrc = podcast.url;
    },
    playNextPodcast() {
      if (!this.currentPodcastList.length) return;
      let next = this.currentPodcastIndex + 1;
      if (next >= this.currentPodcastList.length) return;
      this.currentPodcastIndex = next;
      this.$nextTick(() => {
        this.podcastAudioSrc = this.currentPodcastList[next].url;
        this.forcePodcastPlay = true;
        this.$nextTick(() => {
          this.forcePodcastPlay = false;
        });
      });
    },
    playPrevPodcast() {
      if (!this.currentPodcastList.length) return;
      let prev = this.currentPodcastIndex - 1;
      if (prev < 0) return;
      this.currentPodcastIndex = prev;
      this.$nextTick(() => {
        this.podcastAudioSrc = this.currentPodcastList[prev].url;
        this.forcePodcastPlay = true;
        this.$nextTick(() => {
          this.forcePodcastPlay = false;
        });
      });
    },
    pauseVideo() {
      if (this.$refs.plyr && this.$refs.plyr.player) {
        this.$refs.plyr.player.pause();
      }
    },
    async loadPodcastSections() {
      try {
        this.podcastSections = (this.sections || [])
          .map((section) => {
            const podcasts = (section.items.data || [])
              .filter((item) => item.audio && item.audio.url)
              .map((item) => ({
                id: item.id,
                title: item.learnable.lesson || item.learnable.title,
                description: item.learnable.description,
                url: item.audio.url,
              }));
            return podcasts.length > 0
              ? { id: section.id, title: section.title, podcasts }
              : null;
          })
          .filter(Boolean);
      } catch (error) {
        this.podcastSections = [];
        window.getApp.sendSnackMessage("Erro ao carregar podcasts", "error");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#course {
  max-width: 770px;
  margin: 0 auto;
  padding-bottom: 90px;
  @media screen and (max-width: 1040px) {
    margin: 0 5%;
  }
}
.course-dashboard {
  display: flex;
  flex-direction: column;
}
.course-header {
  position: relative;
  padding: 10px 22px;
  margin-top: 16px;
  border-radius: 20px;
  color: white;
  margin-bottom: 16px;
  z-index: 1;
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(
      135deg,
      black 0%,
      black 65%,
      var(--v-primary-darken2) 66%,
      var(--v-primary-darken2) 75%,
      var(--v-primary-darken1) 76%,
      var(--v-primary-darken1) 85%,
      var(--v-primary-base) 86%,
      var(--v-primary-base) 100%
    );
    z-index: -1;
    border-radius: 20px;
    pointer-events: none;
  }
}
.dash-line {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  @media screen and (min-width: 1000px) {
    flex-wrap: nowrap;
  }
  flex-wrap: wrap;

  .stats {
    position: relative;
    display: flex;
    align-items: center;
    padding: 22px;
    line-height: 1.1;
    color: var(--v-primary-base);
    border-radius: 20px;
    @media screen and (max-width: 600px) {
      width: 100%;
    }
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: var(--v-primary-base);
      opacity: 0.2;
      z-index: 0;
      border-radius: 20px;
      pointer-events: none;
    }
  }
  .cta {
    @extend .stats;
    justify-content: space-around;
    background-color: var(--v-primary-base);
    color: white !important;
    font-size: 24px;
    padding: 16px;
    height: 83px;
    width: 100%;
    cursor: pointer;
    &::before {
      display: none;
    }
  }
  .cta-nao-preparatorio {
    @extend .stats;
    width: 368px;
    height: 102px;
    justify-content: space-around;
    background-color: var(--v-primary-base);
    color: white !important;
    font-size: 24px;
    @media screen and (max-width: 600px) {
      width: 100%;
    }
  }
  .cta-stats-column {
    display: flex;
    flex-direction: column;
    gap: 16px;
    @media screen and (max-width: 600px) {
      width: 100%;
    }
  }
  .cta-stats-row {
    display: flex;
    gap: 16px;
    span {
      white-space: nowrap;
    }
    @media screen and (max-width: 700px) {
      flex-direction: column;
      width: 100%;
      span {
        white-space: wrap;
      }
    }
  }
  .mock-stats {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
  .mock-numbers {
    display: flex;
    flex-direction: column;
    align-items: center;
    line-height: 1;
  }
  .aulas-assistidas {
    display: flex;
    align-items: baseline;
    @media screen and (max-width: 420px) {
      align-items: center;
    }
  }
  .enfase {
    font-size: 50px;
    font-weight: 500;
    margin-left: 5px;
    @media screen and (max-width: 500px) {
      font-size: 40px;
    }
    @media screen and (max-width: 390px) {
      font-size: 35px;
    }
  }
  .span-enfase {
    white-space: nowrap;
    font-size: 20px;
    @media screen and (max-width: 420px) {
      white-space: wrap;
    }
  }
  .text-center-420 {
    white-space: nowrap;
    @media screen and (max-width: 420px) {
      text-align: center;
      white-space: wrap;
    }
  }
}
#aprovacao {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  @media (max-width: 770px) {
    flex-direction: column;
    align-items: flex-start;
  }
  .explanation {
    max-width: 380px;
  }
  .progress {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
}
.progress-status {
  height: 15px;
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  .stage {
    min-width: 25%;
    display: flex;
    justify-content: center;
    align-items: center;
    .span-status {
      font-size: 16px;
      white-space: nowrap;
      z-index: 1;
    }
  }
}
.progress-bar {
  height: 15px;
  width: 100%;
  background: linear-gradient(
    to right,
    #e57373 0%,
    #e57373 25%,
    #ffb74d 25%,
    #ffb74d 50%,
    #fff176 50%,
    #fff176 75%,
    #81c784 75%,
    #81c784 100%
  );
  border-radius: 7.5px;
}
.probabilidade-title {
  white-space: nowrap;
  @media (max-width: 370px) {
    font-size: 22px;
  }
}
.custom-circle {
  position: relative;
  top: -2px;
  left: calc(var(--user-probability, 50%) - 3%);
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: white;
  border: 3px solid blue;
}
.fixed-podcast-player {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background: #fff;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.08);
  display: flex;
  justify-content: center;
  padding: 0.5rem 0;
  border: none;
  border-top: 1px solid #e0e0e0;
  margin-bottom: 16px;
}
@media (max-width: 600px) {
  .v-tab {
    min-width: 48px !important;
    padding: 0 8px !important;
  }
}
</style>
